import { useContext } from "react";
import { RecordContext } from "../../../components/record/Record";
import { RecordsRelated } from "../../../components/recordsRelated/RecordsRelated";
import { IntakeForm, findLastFormsBeforeDoneReportSession } from "./IntakeForm";
import { REPORTS_FIRST_SERVICE } from "../../../utils/constants";
import { getClientAgeAtTreatment, getIntakeFormTypeFromAge } from "../../../utils/getClientAge";

export const SelectIntakeForm = () => {
	const parentContext = useContext(RecordContext);

    const sessions = parentContext?.item?.sessions || [];
    const doneReportSession = sessions.find(
        (session: any) => session.service?.id === REPORTS_FIRST_SERVICE && session.status === "done"
    );

    const entity = getIntakeFormTypeForTreatment(parentContext?.item, doneReportSession?.end_date)

    return (
        <RecordsRelated
            entity={entity}
            fieldsToQuery=""
            fieldToFilter="treatment"
            recordsOptions={{
                relatedRecords: { hideCreationButton: true },
                extraOptions: { sort: "-date_created" }
            }}
            customComponentContent={<IntakeForm doneReportSessionDate={doneReportSession?.end_date} />}
        />
    );
};

export const getIntakeFormTypeForTreatment = (treatment: any, doneReportSessionEndDate?: string) => {
    const allIntakeForms = [
        ...(treatment?.intake_form_child ?? []),
        ...(treatment?.intake_form_adult ?? []),
    ];
    const referenceForm = findLastFormsBeforeDoneReportSession(allIntakeForms, doneReportSessionEndDate);
    const intakeFormType = getIntakeFormTypeByClientAge(
        treatment?.client?.birthday,
        treatment?.date_created,
        treatment?.age_when_started,
        referenceForm?.date_created
    );
    return intakeFormType;
};

const getIntakeFormTypeByClientAge = (clientBirthDate: string, treatmentCreatedDate: string, ageWhenStarted: number, referenceDate?: string) => {
    const clientAge = getClientAgeAtTreatment(clientBirthDate, treatmentCreatedDate, ageWhenStarted)
    return `intake_forms_${getIntakeFormTypeFromAge(clientAge)}` as "intake_forms_child" | "intake_forms_adult"
}
